/**
 * Build identity, inlined by CRA at build time from .env.production.local
 * (written by scripts/write-build-info.js).
 *
 * A dev server has none of these set, which is correct — nothing built it.
 */

export const APP_VERSION = process.env.REACT_APP_VERSION || '';
export const GIT_SHA = process.env.REACT_APP_GIT_SHA || '';
export const GIT_REF = process.env.REACT_APP_GIT_REF || '';
export const BUILT_AT = process.env.REACT_APP_BUILT_AT || '';

/** `v1.2.0` when built, `local` on a dev server. */
export const versionLabel = APP_VERSION ? `v${APP_VERSION}` : 'local';

/** `v1.2.0 · a1b2c3d4` — enough to find the exact commit that is serving. */
export const buildLabel = [versionLabel, GIT_SHA].filter(Boolean).join(' · ');

/** Every field that is set, for the System Health panel. */
export function buildDetails(): Array<{ label: string; value: string }> {
  return [
    { label: 'Version', value: APP_VERSION || 'local dev server' },
    { label: 'Commit', value: GIT_SHA || '—' },
    { label: 'Ref', value: GIT_REF || '—' },
    { label: 'Built', value: BUILT_AT || '—' },
  ];
}
